/* eslint-disable react/prop-types */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMember } from 'hooks/member';

export const RequireAuth = ({ children, redirectTo, strict }) => {
  const { initialized, isLoggedIn, isSoftLoggedIn } = useMember();
  if (initialized) {
    if (isLoggedIn || (!strict && isSoftLoggedIn)) {
      return children;
    }
    return <Navigate to={redirectTo || '/login'} replace />
  }
  return null;
};

export const RequireInitializedMember = ({ children }) => {
  const { initialized } = useMember();
  if (initialized) {
    return children;
  }
  return null;
};
